<template>
  <div>
    <div>
      <div v-if="Busy == true">
        <CCol sm="12" md="12">
          <div class="app flex-row align-items-center">
            <div class="container d-flex justify-content-center">
              <PulseLoader float />
            </div>
          </div>
        </CCol>
      </div>
      <div v-else>
        <CCol sm="12">
          <CRow>
            <CCol sm="4">
              <CInput
                type="text"
                placeholder="Search text"
                v-model.lazy="SearchQuery"
                @change="ApplyFilter()"
              />
            </CCol>
          </CRow>

          <CRow> </CRow>
        </CCol>
        <CCol sm="12">
          <CRow>
            <CCol sm="6">
              <div>
                <!-- <CButton
                  class="btn-success"
                  type="button"
                  @click="OpenFormMassGroup()"
                  ><CIcon name="cil-plus" /> Create Group</CButton
                > -->
              </div>
            </CCol>
          </CRow>
        </CCol>
        <CCol sm="12">
          <CDataTable
            :bordered="bordered"
            :small="small"
            :fixed="fixed"
            :items="FilteredNoti"
            :fields="fields"
            items-per-page-select
            :items-per-page="small ? 5 : 10"
            :dark="dark"
            clickable-rows
            sorter
            pagination
          >
            <template #GroupName="{ item }">
              <td>
                <h6 style="color: #1e109c" class="text-uppercase">
                  {{ item.GroupName }}
                </h6>
              </td>
            </template>

            <template #Description="{ item }">
              <td>
                {{ item.Description }}
              </td>
            </template>
            <template #Action="{ item }">
              <td>
                <CButton
                  class="btn-info ml-2"
                  type="button"
                  @click="GotoEdit(item)"
                >
                  <CIcon name="cilPencil"
                /></CButton>
                <CButton
                  class="btn-success ml-2"
                  type="button"
                  @click="GotoAdd(item)"
                  ><CIcon name="cil-plus"
                /></CButton>
                <CButton
                  class="btn-warning ml-2"
                  type="button"
                  @click="GotoSendMass(item)"
                >
                  <CIcon name="cilCursor"
                /></CButton>
                <CButton
                  class="btn-danger ml-2"
                  type="button"
                  @click="DeleteGroup(item)"
                >
                  <CIcon name="cil-trash"
                /></CButton>
              </td>
            </template>
          </CDataTable>
        </CCol>

        <CModal title="Add Group" size="lg" :show.sync="MassModal">
          <div>
            <h6><strong>FORM GROUP</strong></h6>
            <br />
            <CCol sm="12">
              <CRow>
                <CCol sm="3"> Group Name </CCol>
                <CCol sm="9">
                  <CInput type="text" v-model="GroupName" />
                </CCol>
                <CCol sm="3"> Description </CCol>
                <CCol sm="9">
                  <CInput type="text" v-model="Description" />
                </CCol>
                <div style="clear: both"></div>
                <hr />
                <CCol sm="12">
                  <table
                    class="table table-responsive-sm table-hover table-outline mb-0 mt-2"
                  >
                    <thead>
                      <th>
                        <input
                          type="checkbox"
                          @click="checkAll()"
                          v-model="isCheckAll"
                        />
                      </th>
                      <th>Student Name</th>
                      <th>Email</th>
                      <th>UserType</th>
                      <th>Tuition Center</th>
                    </thead>
                    <tbody>
                      <tr v-for="item in users" v-bind:key="item.Id">
                        <td>
                          <input
                            type="checkbox"
                            id="checkbox"
                            v-model="item.isChecked"
                          />
                        </td>
                        <td>
                          {{ item.Name }}
                        </td>
                        <td>
                          {{ item.ParentEmail }}
                        </td>
                        <td>
                          {{ item.UserType }}
                        </td>
                        <td>
                          {{ item.TuitionCenter }}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </CCol>
              </CRow>
            </CCol>
          </div>
          <template #footer>
            <CButton
              type="submit"
              class="p-2"
              color="info"
              @click="InsertGroupMass()"
              >Proceed</CButton
            ></template
          >
        </CModal>

        <CModal title="List People" size="lg" :show.sync="ListPeopleMassModal">
          <table class="table table-responsive">
            <thead>
            <th>Name</th>
            <th>Email</th>
            <th>Phone Number</th>
            <th>UserType</th>
            <th>Group Name</th>
            <th>Action</th>
          </thead>
            <tbody>
              <tr v-for="item in users" v-bind:key="item.Id">
                <td>{{ item.User }}</td>
                <td>{{ item.Email }}</td>
                <td>{{ item.PhoneNumber }}</td>
                <td>{{ item.UserType }}</td>
                <td>{{ item.GroupName }}</td>
                <td><CButton type="button" color="danger" @click="DeleteUser(item)">X</CButton></td>
              </tr>
            </tbody>
          </table>
        </CModal>

        <CModal title="Add People In Mass Group" size="lg" :show.sync="ListPeopleModal">
          <div>
                  <input
                        type="checkbox"
                        @click="checkAllStudent()"
                        v-model="isCheckAllStudent"
                      /> Select All Student
                </div>
                <CDataTable
                  :hover="hover"
                  :striped="striped"
                  :bordered="bordered"
                  :small="small"
                  :fixed="fixed"
                  :items="FilteredUserListPeople"
                  :fields="fieldsPeople"
                  items-per-page-select
                  :items-per-page="small ? 5 : 10"
                  :dark="dark"
                  columnFilter
                  pagination
                >
                <input
                        type="checkbox"
                        @click="checkAllStudent()"
                        v-model="isCheckAllStudent"
                      /> Select All Student
                <template #Select="{ item }">
                    <td>
                      <input
                          type="checkbox"
                          id="checkbox"
                          v-model="item.isCheckedStudent"
                        />
                    </td>
                  </template>
             
                </CDataTable>
                <template #footer>
          <CButton
            type="submit"
            class="p-2"
            color="info"
            @click="InsertPeople()"
            >Proceed</CButton
          ></template
        >
        </CModal>

        <CModal
        title="Send Mass Notification"
        size="lg"
        :show.sync="SendModal"
        :close-on-backdrop="false"
        :close-on-esc="false"
      >
        <div>
          <CCol sm="12">
            <CRow>
              <CCol sm="3"> Group Name </CCol>
              <CCol sm="9">
                {{ GroupNames }}
              </CCol>
              <CCol sm="3" class="mt-2"> Title </CCol>
              <CCol sm="9" class="mt-2">
                <CInput type="text" v-model="TitleMessage" />
              </CCol>
              <CCol sm="3"> Description </CCol>
              <CCol sm="9">
                <CInput type="text" v-model="DescriptionMessage" />
              </CCol>
           
            </CRow>
          </CCol>
        </div>
        <template #footer>
          <CButton
            type="submit"
            class="p-2"
            color="info"
            @click="InsertNotification()"
            >{{  lblMessage }}</CButton
          ></template
        >
      </CModal>
      </div>
    </div>
  </div>
</template>
  
  <script>
import Vue from "vue";
Vue.use(require("vue-moment"));
import FullCalendar from "vue-full-calendar";
import "fullcalendar/dist/fullcalendar.css";
import VCalendar from "v-calendar";
import VueCal from "vue-cal";
import "vue-cal/dist/vuecal.css";

import _ from "lodash";
import PulseLoader from "vue-spinner/src/PulseLoader.vue";
import { CChartBar } from "@coreui/vue-chartjs";
import VueEllipseProgress from "vue-ellipse-progress";

//import "@fullcalendar/core/vdom"; // solves problem with Vite]

import { Calendar } from "vue-sweet-calendar";
import "vue-sweet-calendar/dist/SweetCalendar.css";
import "material-design-icons-iconfont/dist/material-design-icons.css";

Vue.use(FullCalendar);
Vue.use(VueEllipseProgress);

import VuejsDialog from "vuejs-dialog";
  import "vuejs-dialog/dist/vuejs-dialog.min.css";
  Vue.use(VuejsDialog);

export default {
  name: "Collapses",
  components: {
    PulseLoader,
    CChartBar,
    Calendar,
    VCalendar,
    VueCal,
  },
  data() {
    return {
      noti: [],
      FilteredNoti: [],
      SearchQuery: "",

      perPage: 10,
      pagination: {},
      currentPage: 1,

      selectedName: "ALL TEACHER",
      nameOptions: [],

      selectedView: "ALL VIEW",
      viewOptions: [],

      Busy: false,

      fields: [{ key: "GroupName" }, { key: "Description" }, { key: "Action" }],
      fieldUserList: [
        { key: "Check" },
        { key: "Name" },
        { key: "ParentName" },
        { key: "Grade" },
        { key: "Class" },
        { key: "Email" },
      ],
      FilteredUserList: [],
      users: [],
      MassModal: false,

      isCheckAll: false,
      isCheckAllStudent: false,
      GroupName: "",
      Description: "",

      ListPeopleMassModal: false,
      ListPeopleModal: false,
      people: [],
      FilteredUserListPeople : [],
      fieldsPeople: [
        { key: "Select" },
        { key: "Name" },
        { key: "Email" },
        { key: "UserType" },
      ],
      small: "",
      fixed: "",

      SendModal: false,
      TitleMessage: "",
      DescriptionMessage: "",

      lblMessage: "Send Notification"
    };
  },
  async mounted() {
    let isAuth = await this.UserAuth();

    if (isAuth) {
      this.Busy = false;
      this.GetNoti();
    } else {
      this.GoToLogin();
    }
  },
  methods: {
    GetNoti() {
      this.Busy = true;
      this.$API
        .get(this.$GetListNotificationMass, {
          withCredentials: true,
        })
        .then((response) => {
          if (response.status == 200 && response.data != null) {
            this.Busy = false;
            this.noti = response.data;
            this.FilteredNoti = this.noti;
          }
        });
    },
    ApplyFilter: function () {
      var arr = _.orderBy(this.noti, ["Description"], ["asc"]);
      if (_.isEmpty(arr) == false) {
        const result = _.filter(arr, ({ Description }) =>
          _.some([
            _.includes(!Description || Description.toLowerCase(), [
              this.SearchQuery.toLowerCase(),
            ]),
          ])
        );
        this.FilteredNoti = result;
      }
    },

    GotoEdit(item) {
      this.GroupName = item.GroupName;
      this.$API
        .get(this.$GetListPeopleNotificationMass + "?groupName=" + this.GroupName, {
          withCredentials: true,
        })
        .then((response) => {
          if (response.status == 200 && response.data != null) {
            this.users = response.data;
            this.FilteredUserList = this.users;
          }
        });

      this.ListPeopleMassModal = true;
    },
    GotoAdd(item) {
      this.GroupName = item.GroupName;
      this.Description = item.Description;
      this.$API
        .get(this.$GetListAllPeople, {
          withCredentials: true,
        })
        .then((response) => {
          if (response.status == 200 && response.data != null) {
            this.people = response.data;
            this.FilteredUserListPeople = this.people;
          }
        });
      this.ListPeopleModal = true;
    },

    InsertGroupMass() {
      const formData = new FormData();
      var count = 0;
      for (var index = 0; index < this.users.length; index++) {
        var pv = this.users[index];
        if (pv.isChecked) {
          formData.append("userList[" + count + "]", pv.Id);
          count++;
        }
      }
      formData.append("GroupName", this.GroupName);
      formData.append("Description", this.Description);

      return this.$API
        .post(this.$InsertMassGroup, formData, {
          withCredentials: true,
        })
        .then((response) => {
          if (response.status == 200 && response.data != null) {
            this.MassModal = false;
            this.$dialog
              .alert("You have successfully create group")
              .then(function () {});
            this.isCheckAll = false;
          }
        })
        .catch((error) => {
          if (error.response) {
            console.log(error.response.status);
            this.Error = true;
            this.Message = error;
            this.Message = "Error";
          }
        });
    },
    DeleteUser(item) {
      const formData = new FormData();

      formData.append("Id", item.Id);

      return this.$API
        .post(this.$DeleteUserMassNoti, formData, {
          withCredentials: true,
        })
        .then((response) => {
          this.info = response.data;

          if (response.status == 200) {
            this.$dialog
              .alert("You have successfully delete user")
              .then(function () {});
              this.$API
        .get(this.$GetListPeopleNotificationMass + "?groupName=" + this.GroupName, {
          withCredentials: true,
        })
        .then((response) => {
          if (response.status == 200 && response.data != null) {
            this.users = response.data;
            this.FilteredUserList = this.users;
          }
        });
          } else console.log("Error Deleting");
        })
        .catch((error) => {
          console.log(error);
        });
    },
    DeleteGroup(item) {
      const formData = new FormData();

      formData.append("GroupName", item.GroupName);

      return this.$API
        .post(this.$DeleteGroupMass, formData, {
          withCredentials: true,
        })
        .then((response) => {
          this.info = response.data;

          if (response.status == 200) {
            this.$dialog
              .alert("You have successfully delete group mass")
              .then(function () {});
              this.GetNoti();
          } else console.log("Error Deleting");
        })
        .catch((error) => {
          console.log(error);
        });
    },
    checkAll: function () {
      this.isCheckAll = !this.isCheckAll;
      var temp = this;
      this.users.forEach(function (item) {
        if (item.isChecked !== temp.isCheckAll) {
          item.isChecked = temp.isCheckAll;
        }
      });
    },
    checkAllStudent: function () {
      this.isCheckAllStudent = !this.isCheckAllStudent;
      var temp = this;
      this.people.forEach(function (item) {
        if (item.isCheckedStudent !== temp.isCheckAllStudent) {
          item.isCheckedStudent = temp.isCheckAllStudent;
        }
      });
    },
    InsertPeople() {
      const formData = new FormData();
      var combinedSubject = [];
      var count = 0;
      for (var index = 0; index < this.people.length; index++) {
            let pv = this.people[index];
            if (pv.isCheckedStudent) {
              let combinedItem = {
                userListId: pv.UserID,
            };
            combinedSubject.push(combinedItem);
          }
        }
    let subjectData = JSON.stringify(combinedSubject);
    formData.append("userList", subjectData);
    formData.append("GroupName", this.GroupName);
      formData.append("Description", this.Description);

      return this.$API
        .post(this.$InsertPeople, formData, {
          withCredentials: true,
        })
        .then((response) => {
          if (response.status == 200 && response.data != null) {
            this.ListPeopleModal = false;
            this.$dialog
              .alert("You have successfully add user")
              .then(function () {});
            this.isCheckAllStudent = false;
          }
        })
        .catch((error) => {
          if (error.response) {
            console.log(error.response.status);
            this.Error = true;
            this.Message = error;
            this.Message = "Error";
          }
        });
    },
    GotoSendMass(item)
    {
      this.GroupNames = item.GroupName;
      this.SendModal = true;
    },
    InsertNotification() {
      this.lblMessage = "Processing";
      const formData = new FormData();

      formData.append("groupName", this.GroupNames);
      formData.append("TitleMessage", this.TitleMessage);
      formData.append("DescriptionMessage", this.DescriptionMessage);

      return this.$API
        .post(this.$InsertNotificationMass, formData, {
          withCredentials: true,
        })
        .then((response) => {
          if (response.status == 200 && response.data != null) {
            this.SendModal = false;
            this.$dialog
              .alert("You have successfully send notification")
              .then(function () {});
            this.isCheckAll = false;
          }
        })
        .catch((error) => {
          if (error.response) {
            console.log(error.response.status);
            this.Error = true;
            this.Message = error;
            this.Message = "Error";
          }
        });
    },
  },
};
</script>
  
  
  <style>
@import url("https://fonts.googleapis.com/css2?family=Open+Sans:wght@600&display=swap");
.custom-btn-success {
  color: #fff;
  background-color: #2eb85c;
  border-color: #2eb85c;
  width: 230px;
}
.style-chooser .vs__open-indicator {
  fill: rgb(251 248 254);
  -webkit-transform: scale(1);
  transform: scale(1);
  -webkit-transition: -webkit-transform 150ms
    cubic-bezier(1, -0.115, 0.975, 0.855);
  transition: -webkit-transform 150ms cubic-bezier(1, -0.115, 0.975, 0.855);
  transition: transform 150ms cubic-bezier(1, -0.115, 0.975, 0.855);
  transition: transform 150ms cubic-bezier(1, -0.115, 0.975, 0.855),
    -webkit-transform 150ms cubic-bezier(1, -0.115, 0.975, 0.855);
  -webkit-transition-timing-function: cubic-bezier(1, -0.115, 0.975, 0.855);
  transition-timing-function: cubic-bezier(1, -0.115, 0.975, 0.855);
}
.style-chooser .vs__clear {
  fill: rgb(251 248 254);
  padding: 0;
  border: 0;
  background-color: transparent;
  cursor: pointer;
  margin-right: 8px;
}
.style-chooser .vs__dropdown-toggle {
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  padding: 0 0 4px 0;
  background: none;
  border: 1px solid #009efb;
  border-radius: 4px;
  white-space: normal;
  height: 36px;
}
.style-chooser .vs__selected {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  background-color: #009efb;
  border: 1px solid #009efb;
  border-radius: 4px;
  color: #fff;
  line-height: 1.4;
  margin: 4px 2px 0px 2px;
  padding: 0 0.25em;
  z-index: 0;
}
.style-chooser .vs__single .vs__selected {
  background-color: #009efb;
  border-color: #009efb;
}
.custom-btn-blue {
  background: #009efb;
  border: 1px solid #009efb;
  color: #ffffff;
  border-radius: 4px;
}
</style>
  
  
  
  